document.addEventListener('alpine:init', () => {
  Alpine.data('gbiTikTokCarousel', (config) => ({
    activeIndex: 0,
    mouseX: 0.5,
    mouseY: 0.5,
    isMobile: false,
    isVisible: false,
    reduceMotion: false,
    stats: (config && config.stats) || [],
    counts: [],
    _interval: null,
    _io: null,
    _resize: null,
    _onMove: null,
    _onLeave: null,
    _sectionUnload: null,

    init() {
      const self = this;
      this.counts = this.stats.map(() => 0);
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.checkMobile();

      this._resize = function () { self.checkMobile(); };
      window.addEventListener('resize', this._resize, { passive: true });

      this._io = new IntersectionObserver(function (entries) {
        if (entries[0] && entries[0].isIntersecting) {
          self.isVisible = true;
          self.startCounters();
          self._io.disconnect();
        }
      }, { threshold: 0.2 });
      this._io.observe(this.$el);

      const totalPhones = config.totalPhones || 0;
      if (config.autoRotate && totalPhones > 1 && !this.reduceMotion) {
        this._interval = setInterval(function () {
          self.activeIndex = (self.activeIndex + 1) % totalPhones;
        }, (config.rotateInterval || 4) * 1000);
      }

      this._onMove = function (e) { self.onMouseMove(e); };
      this._onLeave = function () { self.onMouseLeave(); };
      this.$el.addEventListener('mousemove', this._onMove, { passive: true });
      this.$el.addEventListener('mouseleave', this._onLeave);

      this._sectionUnload = function (e) {
        if (self.$el && self.$el.closest('.shopify-section') === e.target) {
          self.destroy();
        }
      };
      document.addEventListener('shopify:section:unload', this._sectionUnload);
    },

    destroy() {
      if (this._interval) { clearInterval(this._interval); this._interval = null; }
      if (this._io) { this._io.disconnect(); this._io = null; }
      if (this._resize) { window.removeEventListener('resize', this._resize); this._resize = null; }
      if (this._onMove) { this.$el.removeEventListener('mousemove', this._onMove); this._onMove = null; }
      if (this._onLeave) { this.$el.removeEventListener('mouseleave', this._onLeave); this._onLeave = null; }
      if (this._sectionUnload) { document.removeEventListener('shopify:section:unload', this._sectionUnload); this._sectionUnload = null; }
    },

    checkMobile() {
      this.isMobile = window.innerWidth < 968;
    },

    onMouseMove(e) {
      if (this.isMobile || this.reduceMotion) return;
      const rect = this.$el.getBoundingClientRect();
      this.mouseX = (e.clientX - rect.left) / rect.width;
      this.mouseY = (e.clientY - rect.top) / rect.height;
    },

    onMouseLeave() {
      this.mouseX = 0.5;
      this.mouseY = 0.5;
    },

    goTo(i) {
      this.activeIndex = i;
    },

    get tiltX() {
      return this.isMobile || this.reduceMotion ? 0 : (this.mouseY - 0.5) * -6;
    },

    get tiltY() {
      return this.isMobile || this.reduceMotion ? 0 : (this.mouseX - 0.5) * 6;
    },

    phoneStyle(index, total) {
      let offset = index - this.activeIndex;
      if (offset > total / 2) offset -= total;
      if (offset < -total / 2) offset += total;
      const abs = Math.abs(offset);
      const isCenter = abs === 0;
      const visible = abs <= 2;
      const xt = offset * (this.isMobile ? 110 : 180);
      const yr = offset * -30;
      const sc = isCenter ? 1 : 1 - abs * 0.15;
      const op = visible ? (isCenter ? 1 : 0.5 - (abs - 1) * 0.2) : 0;
      const zi = 100 - abs * 10;
      const bl = isCenter ? 0 : abs * 1.5;
      return 'transform: translate(-50%, -50%) translateX(' + xt + 'px) rotateY(' + yr + 'deg) scale(' + sc + '); opacity: ' + op + '; z-index: ' + zi + '; filter: blur(' + bl + 'px); cursor: ' + (isCenter ? 'default' : 'pointer') + ';';
    },

    startCounters() {
      const self = this;
      const duration = 2200;
      this.stats.forEach(function (stat, i) {
        const target = Number(stat.value) || 0;
        if (!target) { self.counts[i] = 0; return; }
        if (self.reduceMotion) { self.counts[i] = target; return; }
        const start = performance.now();
        const tick = function (now) {
          const elapsed = now - start;
          const t = Math.min(elapsed / duration, 1);
          const eased = 1 - Math.pow(1 - t, 3);
          self.counts[i] = Math.floor(eased * target);
          if (t < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
      });
    },

    formatStat(i) {
      const stat = this.stats[i];
      if (!stat) return '';
      const val = (this.counts[i] || 0).toLocaleString();
      return (stat.prefix || '') + val + (stat.suffix || '');
    }
  }));
});
